import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api, BASE } from '../api';

/** PTI's logo once uploaded (Settings → Branding); the built-in "P" mark until then. */
export function useBranding() {
  return useQuery({ queryKey: ['branding'], queryFn: () => api.public<{ logoVersion: string | null }>('GET', '/api/public/branding'), staleTime: 5 * 60_000 });
}

export function BrandMark({ size = 'md', onDark }: { size?: 'sm' | 'md' | 'lg'; onDark?: boolean }) {
  const b = useBranding();
  const [broken, setBroken] = useState<string | null>(null);
  const v = b.data?.logoVersion;
  if (v && broken !== v) {
    return <span className={`logo-box ${size}${onDark ? ' on-dark' : ''}`}><img src={`${BASE}/api/public/logo?v=${v}`} alt="Perth Training Institute" onError={() => setBroken(v)} /></span>;
  }
  return <span className={`mark${size === 'sm' ? ' sm' : ''}`} aria-hidden="true">P</span>;
}
